<template>
  <div
    v-if="visible"
    class="ba-overlay"
    role="dialog"
    aria-modal="true"
    :aria-labelledby="titleId"
    @click.self="dismiss"
  >
    <div class="ba-modal">
      <button
        class="ba-close"
        @click="dismiss"
        aria-label="Stäng meddelande"
      >
        ×
      </button>
      <h2 :id="titleId" class="ba-title">Hej kompis!</h2>
      <p class="ba-text">
        Alexander på LiveGBG här. Nu har jag grejat och grejat och tillslut
        löst så att man kan se genre på nästan alla evenemang. Detta är
        fortfarande i test-läge, men tänker att du säkert har nytta av det
        ändå. 
        <br><br>
        Du kan även nu skapa ett konto här på sidan och spara konserter som du är intresserad av, så att de blir lättare att hitta igen. Det är helt gratis och kräver bara en e-postadress. 
        <br><br>
      
        
        Om du skulle upptäcka att något är jättefel med det så får
        du gärna höra av dig till mig på
        <a href="mailto:hello@livegbg.se" class="ba-email">hello@livegbg.se</a>.

        <br><br>
        Och just det... Nu kan man även köpa sig en tshirt med LiveGBG-tryck på också, om man vill bli lite extra snygg på konsterter (och stötta detta lilla passion-projekt). Kolla in <a @click="dismiss" href="https://www.livegbg.se/merch" class="ba-email">här</a> om du är sugen...
      </p>
      <p class="ba-text ba-text--signoff">Ha det fint!</p>
      <div class="ba-actions">
        <button class="ba-btn" @click="dismiss">Tack, du med!</button>
      </div>
    </div>
  </div>
</template>

<script>
// Versioned key — bumpa "v1" till "v2" när du vill visa ett nytt
// meddelande som även återanvändare ska se. Dismiss-state är per
// version, så folk slipper se gamla meddelanden om de redan klickat
// bort dem.
const STORAGE_KEY = "livegbg_announcement_genre_v1";
// Sekunder innan popupen visas (när användaren landat på sidan).
const DELAY_SECONDS = 15;

export default {
  name: "BetaAnnouncement",
  data() {
    return {
      visible: false,
      timer: null,
      titleId: "beta-announcement-title",
    };
  },
  mounted() {
    if (this.alreadyDismissed()) return;
    this.timer = setTimeout(() => {
      this.visible = true;
    }, DELAY_SECONDS * 1000);
  },
  beforeUnmount() {
    if (this.timer) {
      clearTimeout(this.timer);
      this.timer = null;
    }
  },
  methods: {
    alreadyDismissed() {
      try {
        return localStorage.getItem(STORAGE_KEY) === "1";
      } catch {
        // Privacy mode / disabled storage → visa popupen ändå, ofarligt
        return false;
      }
    },
    dismiss() {
      this.visible = false;
      try {
        localStorage.setItem(STORAGE_KEY, "1");
      } catch {
        // Storage disabled — popupen kommer dyka upp nästa session
        // men det är acceptabelt
      }
    },
  },
};
</script>

<style scoped>
.ba-overlay {
  position: fixed;
  inset: 0;
  z-index: 600; /* över cookie-banner (500) och sidebar (är typiskt 400-500) */
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1.5rem;
  animation: ba-fade-in 0.2s ease-out;
}

.ba-modal {
  position: relative;
  background-color: var(--color-bg, #f5f0e8);
  border: 1px solid var(--color-border, #e0d9d0);
  max-width: 480px;
  width: 100%;
  padding: 2.5rem 2rem 1.75rem;
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.25);
  animation: ba-pop-in 0.25s ease-out;
}

.ba-close {
  position: absolute;
  top: 0.5rem;
  right: 0.75rem;
  background: none;
  border: none;
  font-size: 1.6rem;
  line-height: 1;
  color: var(--color-text-muted, #888);
  cursor: pointer;
  padding: 0.25rem 0.5rem;
  font-family: inherit;
}

.ba-close:hover {
  color: var(--color-accent, #cc1100);
}

.ba-close:focus-visible {
  outline: 2px solid var(--color-accent, #cc1100);
  outline-offset: 2px;
}

.ba-title {
  font-family: "Playfair Display", serif;
  font-size: 1.6rem;
  font-weight: 700;
  color: var(--color-text, #1a1a1a);
  margin-bottom: 1rem;
}

.ba-text {
  font-size: 0.95rem;
  line-height: 1.55;
  color: var(--color-text-secondary, #555);
  margin-bottom: 0.75rem;
}

.ba-text--signoff {
  margin-bottom: 1.5rem;
}

.ba-email {
  color: var(--color-accent, #cc1100);
  text-decoration: underline;
  text-underline-offset: 2px;
}

.ba-email:hover {
  opacity: 0.85;
}

.ba-actions {
  display: flex;
  justify-content: flex-end;
}

.ba-btn {
  background-color: var(--color-text, #1a1a1a);
  color: var(--color-bg, #f5f0e8);
  border: 1px solid var(--color-text, #1a1a1a);
  padding: 0.5rem 1.3rem;
  font-size: 0.75rem;
  font-family: inherit;
  font-weight: 600;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  cursor: pointer;
  transition: background-color 0.15s ease, border-color 0.15s ease;
}

.ba-btn:hover {
  background-color: var(--color-accent, #cc1100);
  border-color: var(--color-accent, #cc1100);
  color: #fff;
}

.ba-btn:focus-visible {
  outline: 2px solid var(--color-accent, #cc1100);
  outline-offset: 2px;
}

@keyframes ba-fade-in {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes ba-pop-in {
  from {
    opacity: 0;
    transform: translateY(8px) scale(0.98);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

@media (max-width: 700px) {
  .ba-modal {
    padding: 2rem 1.25rem 1.25rem;
  }

  .ba-title {
    font-size: 1.4rem;
  }

  .ba-text {
    font-size: 0.9rem;
  }
}
</style>
